"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PollFillSquircle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_PollFillSquircle_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.436 2.184C0 3.04 0 4.16 0 6.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C3.04 16 4.16 16 6.4 16h3.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C16 12.96 16 11.84 16 9.6V6.4c0-2.24 0-3.36-.436-4.216A4 4 0 0 0 13.816.436C12.96 0 11.84 0 9.6 0H6.4C4.16 0 3.04 0 2.184.436A4 4 0 0 0 .436 2.184ZM3 8a1 1 0 0 0-1 1v3.25a1 1 0 0 0 1 1h1.375a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H3Zm3.313-4.25a1 1 0 0 1 1-1h1.375a1 1 0 0 1 1 1v8.5a1 1 0 0 1-1 1H7.312a1 1 0 0 1-1-1v-8.5ZM11.625 5a1 1 0 0 0-1 1v6.25a1 1 0 0 0 1 1H13a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1.375Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_PollFillSquircle_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = PollFillSquircle;
exports["default"] = _default;